/**
 * Remove cookies for the current host (dev recovery after proxy-loop 431 errors).
 */
export function clearSiteCookies () {
  const parts = document.cookie.split(';')
  for (const part of parts) {
    const eq = part.indexOf('=')
    const name = (eq > -1 ? part.slice(0, eq) : part).trim()
    if (!name) continue
    document.cookie = `${name}=; Max-Age=0; path=/`
    document.cookie = `${name}=; Max-Age=0; path=/api`
  }
}
